import { ErrorType } from 'data/App/types'

import { FETCH_CURRENCIES, FETCH_ERROR_CURRENCIES, FETCH_SUCCESS_CURRENCIES } from './actionTypes'
import { ApiCurrency } from './types'

export type FetchAction = {
  type: typeof FETCH_CURRENCIES
}
export const fetch = (): FetchAction => ({
  type: FETCH_CURRENCIES
})

type FetchSuccessAction = {
  payload: ApiCurrency[]
  type: typeof FETCH_SUCCESS_CURRENCIES
}
export const fetchSuccess = (currencies: ApiCurrency[]): FetchSuccessAction => ({
  payload: currencies,
  type: FETCH_SUCCESS_CURRENCIES
})

type FetchErrorAction = {
  error: ErrorType
  type: typeof FETCH_ERROR_CURRENCIES
}
export const fetchError = (error: ErrorType): FetchErrorAction => ({
  error,
  type: FETCH_ERROR_CURRENCIES
})

export type CurrenciesActions = FetchAction | FetchSuccessAction | FetchErrorAction
